import WatchListEntriesTable from './WatchListEntriesTable';

export default WatchListEntriesTable;


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/components/watch-list-entries-table/index.js